const translations = {
    batteryButtonText: 'Battery',
    droneButtonText: 'Drone'
};

export default translations;
